export default __webpack_public_path__ + "static/media/landscape.ac947051.png";